// extracted by mini-css-extract-plugin
module.exports = {"pinkBg":"PinkBlock_pinkBg__1O9il","stepNum":"PinkBlock_stepNum__3g3AO"};